/* eslint-disable import/no-anonymous-default-export */
const SearchIcon = ()=>(
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.74999 15.8334C12.662 15.8334 15.8333 12.662 15.8333 8.75002C15.8333 4.83802 12.662 1.66669 8.74999 1.66669C4.83799 1.66669 1.66666 4.83802 1.66666 8.75002C1.66666 12.662 4.83799 15.8334 8.74999 15.8334Z" stroke="currentColor" strokeWidth="1.25" strokeLinejoin="round"/>
        <path d="M13.8424 13.8423L17.3779 17.3779" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
)

export default {SearchIcon}